/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Boundary_DescriptionInputs */

const es_error_boundary_description = /** @type {(inputs: Error_Boundary_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ocurrió un error inesperado. Por favor, recarga la página.`)
};

const en_error_boundary_description = /** @type {(inputs: Error_Boundary_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`An unexpected error occurred. Please reload the page.`)
};

/**
* | output |
* | --- |
* | "An unexpected error occurred. Please reload the page." |
*
* @param {Error_Boundary_DescriptionInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const error_boundary_description = /** @type {((inputs?: Error_Boundary_DescriptionInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Boundary_DescriptionInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_error_boundary_description(inputs)
	return en_error_boundary_description(inputs)
});
export { error_boundary_description as "error_boundary.description" }